// Versões correntes dos documentos legais. Quando atualizar os arquivos
// em web/src/content/legal/, atualize estas constantes E também os envs
// LEGAL_TERMS_VERSION / LEGAL_PRIVACY_VERSION da API.

export const CURRENT_TERMS_VERSION = '2026-06-01';
export const CURRENT_PRIVACY_VERSION = '2026-08-20';

import termsContent from '../content/legal/terms-2026-06.md?raw';
import privacyContent from '../content/legal/privacy-2026-08.md?raw';

export const TERMS_CONTENT = termsContent;
export const PRIVACY_CONTENT = privacyContent;
